import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import { CdkDrag } from '@angular/cdk/drag-drop';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { first, map, takeUntil } from 'rxjs/operators';
import { ZalamoDialogService } from '../../zalamo-dialog/zalamo-dialog.service';
import { PhotoSelectionComponent } from '../photo-selection/photo-selection.component';
import { CoverImageSize } from '../types';
import { DomSanitizer } from '@angular/platform-browser';
import { UploadService } from '../../../upload/upload.service';

@Component({
    selector: 'lib-select-photo-position',
    templateUrl: './select-photo-position.component.html',
    styleUrls: ['./select-photo-position.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectPhotoPositionComponent implements OnInit {
  @Input() isBooking = false;
  @Input() selectedPoint = false;
  @Input() imageSize: CoverImageSize = { w: 1200, h: 150 };
  xInPx = 100;
  yInPx = 100;
  transition = [];
  widthPhoto = 100;
  heightPhoto = 100;
  widthText = 90;
  heightText = 25;
  xText = 100;
  yText = 100;
  sizeText = 10;
  numberW = 0;
  numberH = 0;
  @Input() fileName: string;
  @ViewChild('ball', {
    static: false,
    read: CdkDrag,
  })
  ballElement: CdkDrag;
  @ViewChild('photoContainer', {
    static: true,
  })
  photoContainer: ElementRef<HTMLElement>;
  @ViewChild('preview', {
    static: false,
  })
  previewElement: TemplateRef<any>;
  @Input() context;
  @Input() contextId;
  @Output() saved = new EventEmitter<{
    x: number;
    y: number;
    size: {
      w: number;
      h: number;
    };
    file: string;
    url: string;
  }>();
  isPhonePortrait$ = this.screenObserver
    .observe(Breakpoints.Handset)
    .pipe(map(({ matches }) => matches));

  private _y = 50;

  get y(): number {
    return this._y;
  }

  @Input() set y(value: number) {
    this._y = value;
  }

  private _x = 50;

  get x(): number {
    return this._x;
  }

  @Input() set x(value: number) {
    this._x = value;
  }

  @Input() private _url;

  get url() {
    return this._url;
  }

  @Input() set url(value) {
    if (typeof value === 'string') {
      this._url = this.sanitizer.bypassSecurityTrustUrl(value);
    } else {
      this._url = value;
    }
  }

  constructor(
    private photo: ElementRef<HTMLElement>,
    private screenObserver: BreakpointObserver,
    private dialog: ZalamoDialogService,
    private sanitizer: DomSanitizer,
    private uploadService: UploadService,
    private cd: ChangeDetectorRef,
  ) {
    console.log(Breakpoints);
  }

  @HostListener('window:resize') resize() {
    this.calc();
  }

  ngOnInit() {
    this.calc();
  }

  calc() {
    /**
     * obliczanie contenera zdjecia
     */
    this.isPhonePortrait$.pipe(first()).subscribe((phone) => {
      const { height, width } =
        this.photo.nativeElement.getBoundingClientRect();
      console.log('wysokość kontenera', height, 'szerokość kontenera', width);
      console.log(
        'wysokość zdjęcia',
        this.imageSize.h,
        'szerokość zdjęcia',
        this.imageSize.w,
      );
      if (!phone) {
        this.numberW = this.imageSize.w / (width * 0.49);
        this.numberH = this.imageSize.h / (height * 0.75);
      }
      if (phone) {
        this.numberW = this.imageSize.w / width;
        this.numberH = this.imageSize.h / (height * 0.85);
      }
      if (this.numberH >= this.numberW) {
        this.heightPhoto = this.imageSize.h / this.numberH;
        this.widthPhoto = this.imageSize.w / this.numberH;
      }
      if (this.numberH < this.numberW) {
        this.heightPhoto = this.imageSize.h / this.numberW;
        this.widthPhoto = this.imageSize.w / this.numberW;
      }
      console.log(
        'wysokość zdjęcia po przeliczeniu',
        this.heightPhoto,
        'szerokość zdjęcia po przeliczeniu',
        this.widthPhoto,
      );
      /**
       * obliczanie rozmiaru i pozycji napisu na zdjęciu
       */
      this.widthText = (this.widthPhoto / 100) * 80;
      this.heightText = this.widthText / 20;
      this.xText = (this.widthPhoto - this.widthText) / 2;
      this.yText = (this.heightPhoto - this.heightText) / 2;
      this.xText = this.xText - (this.xText / 100) * 30;
      this.yText = this.yText - (this.yText / 100) * 3;
      if (this.widthPhoto >= this.heightPhoto) {
        this.sizeText = this.xText / 1.8;
      }
      if (this.widthPhoto < this.heightPhoto) {
        this.sizeText = this.yText / 18;
      }
      this.yInPx = (this.y / 100) * this.heightPhoto - 10;
      this.xInPx = (this.x / 100) * this.widthPhoto - 10;
    });
  }

  clickPoint(event: MouseEvent): void {
    this.selectedPoint = true;
    this.transition = ['.4s'];

    // @ts-ignore
    if (event.target.classList.contains('ball')) {
      return;
    }
    this.xInPx = event.offsetX - 10;
    this.yInPx = event.offsetY - 10;
    this._x = (event.offsetX / this.widthPhoto) * 100;
    this._y = (event.offsetY / this.heightPhoto) * 100;
    console.log('procenty x', this._x, 'procenty y', this._y);
    this.ballElement?.reset();
  }

  startDrag() {
    this.transition = [`0s`];
  }

  endDrag() {
    this._x =
      ((this.xInPx + this.ballElement.getFreeDragPosition().x) /
        this.widthPhoto) *
      100;
    this._y =
      ((this.yInPx + this.ballElement.getFreeDragPosition().y) /
        this.heightPhoto) *
      100;
    console.log('procenty x', this._x, 'procenty y', this._y);
  }

  openFull() {
    const ref = this.dialog.openFull(this.previewElement, {
      isBare: true,
    });
  }

  openFullPhotoSelection() {
    const ref = this.dialog.openFull(PhotoSelectionComponent);
    ref.componentInstance.context = this.context;
    ref.componentInstance.contextId = this.contextId;
    ref.componentInstance.filePicked
      .pipe(takeUntil(ref.afterClosed()))
      .subscribe(({ fileName, size }) => {
        this.uploadService
          .getSingleFileUrl(fileName, { h: 2048, w: 2048 })
          .pipe(first())
          .subscribe((url) => {
            this.url = url;
            this.imageSize = size;
            this._x = 50;
            this._y = 50;
            this.fileName = fileName;
            this.ballElement?.reset();
            this.calc();
            this.cd.detectChanges();
            ref.close();
          });
      });
  }

  save() {
    this.saved.emit({
      x: this._x,
      y: this._y,
      size: this.imageSize,
      url: this.url,
      file: this.fileName,
    });
  }
}
